import React from 'react';
import { Box, Typography, Button, Modal, IconButton, Divider, CircularProgress } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useConfirmModal } from './styles';
import { useTranslation } from 'react-i18next';

interface ConfirmModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
  onCancel?: () => void; // Nueva prop opcional para manejar la cancelación
  title: string;
  description?: string;
  children?: JSX.Element
}

export const ConfirmModal: React.FC<ConfirmModalProps> = ({
  open,
  onClose,
  onConfirm,
  onCancel,
  title,
  description,
  children
}) => {
  const styles = useConfirmModal();
  const { t } = useTranslation()
  const [isDeleting, setIsDeleting] = React.useState(false);

  const handleConfirm = async () => {
    setIsDeleting(true);
    try {
      await onConfirm();
      onClose();
    } catch (error) {
      console.log(error)
    } finally {
      setIsDeleting(false);
    }
  };

  const handleCancel = () => {
    onCancel ? onCancel() : onClose();
  };

  return (
    <Modal open={open} onClose={() => !isDeleting && handleCancel()}>
      <Box sx={styles.container}>
        <IconButton
          aria-label="close"
          onClick={handleCancel}
          disabled={isDeleting}
          sx={styles.closeIcon}
        >
          <CloseIcon />
        </IconButton>

        <Box sx={{ padding: 3 }}>
          <Typography variant="h6" component="h2" fontWeight={600} sx={{ mb: description ? 4 : 2 }}>
            {title}
          </Typography>
          {description && <Typography sx={styles.description}>{description}</Typography>}
          {children}
        </Box>

        <Divider sx={{ mt: 3, mb: 0, width: '100%' }} />

        <Box sx={styles.btnContainer}>
          <Button
            onClick={handleCancel}
            disabled={isDeleting}
            sx={styles.cancelBtn}
          >
            {t('reportFolio.detail.general.cancel')}
          </Button>
          <Button
            onClick={handleConfirm}
            disabled={isDeleting}
            sx={styles.confirmBtn}
          >
            {isDeleting ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              t('reportFolio.detail.general.confirm')
            )}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};